<div
  class="orgApp-holidays-main-container orgApp-flex-dir-col orgApp-d-flex orgApp-gap-24"
>
  <div class="orgApp-gap-8 orgApp-d-flex orgApp-justify-c-spc-btw">
    <div
      class="orgApp-flex-dir-col orgApp-d-flex orgApp-create-holiday-header orgApp-gap-8"
    >
      <h2 mat-dialog-title class="orgApp-create-holiday-title" mat-dialog-title>
        <b>{{ editFormData.title | translate }}</b>
      </h2>
      <p class="orgApp-create-holiday-sub-title">
        {{ editFormData.sub_title | translate }}
      </p>
    </div>
    <div class="orgApp-holidays-header-btn-div">
      <button
        type="button"
        class="orgApp-holidays-header-button"
        mat-icon-button
        (click)="cancelForm()"
      >
      <svg width="24" height="24">
        <use xlink:href="#close-icon"></use>
      </svg>
      </button>
    </div>
  </div>
  <mat-dialog-content class="orgApp-holiday-dialog-content">
    <form [formGroup]="createHolidaysForm">
      <div
        class="orgApp-holidays-content-container orgApp-flex-dir-col orgApp-d-flex orgApp-gap-24"
      >
        <div class="orgApp-flex-dir-col orgApp-d-flex orgApp-gap-16">
          <div
            class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-8"
            *ngIf="duplicateError || dateError || timeError"
          >
            <div
              class="orgApp-d-flex orgApp-holidays-error-div orgApp-gap-8"
              *ngIf="duplicateError"
            >
              <div class="orgApp-holidays-error-icon-div">
                <svg width="20" height="20" class="orgApp-margin-top-6">
                  <use xlink:href="#error-warn-icon"></use>
                </svg>
              </div>
              <span>{{
                "holidays.create_holiday-dialog.content.error_message.duplicate_error"
                  | translate
              }}</span>
            </div>

            <div
              class="orgApp-d-flex orgApp-holidays-error-div orgApp-gap-8"
              *ngIf="dateError || timeError"
            >
              <div class="orgApp-holidays-error-icon-div">
                <svg width="20" height="20" class="orgApp-margin-top-4">
                  <use xlink:href="#error-warn-icon"></use>
                </svg>
              </div>
              <div class="orgApp-d-flex orgApp-flex-dir-col">
                <span *ngIf="dateError">{{
                  "holidays.create_holiday-dialog.content.error_message.date_error"
                    | translate
                }}</span>
                <span *ngIf="timeError">{{
                  "holidays.create_holiday-dialog.content.error_message.time_error"
                    | translate
                }}</span>
              </div>
            </div>
          </div>

          <div
            class="orgApp-flex-dir-col orgApp-d-flex orgApp-gap-24 orgApp-create-holidays-form"
          >
            <mat-form-field
              appearance="outline"
              class="orgApp-field-rounded-sm orgApp-input-field"
            >
              <mat-label>{{
                "holidays.create_holiday-dialog.content.label.name" | translate
              }}</mat-label>
              <input
                matInput
                id="name"
                formControlName="name"
                placeholder="{{
                  'holidays.create_holiday-dialog.content.placeholder.name'
                    | translate
                }}"
              />
            </mat-form-field>

            <mat-radio-group
            formControlName="holidayType"
            class="orgApp-d-flex orgApp-gap-24"
          >
            <mat-radio-button
              value="FULL_DAY"
              class="orgApp-hol-type-radio-btn orgApp-radio-btn-primary"
              (change)="($event)"
            >
              {{ "holidays.create_holiday-dialog.content.label.all_day_event" | translate }}
            </mat-radio-button>
            <mat-radio-button
              value="FIRST_HALF"
              class="orgApp-hol-type-radio-btn orgApp-radio-btn-primary"
              (change)="($event)"
            >
              {{ "holidays.create_holiday-dialog.content.label.first_half" | translate }}
            </mat-radio-button>
            <mat-radio-button
              value="SECOND_HALF"
              class="orgApp-hol-type-radio-btn orgApp-radio-btn-primary"
              (change)="($event)"
            >
             {{ "holidays.create_holiday-dialog.content.label.second_half" | translate }}
            </mat-radio-button
            >
          </mat-radio-group>
            
            
            <div class="orgApp-flex-dir-col orgApp-d-flex orgApp-gap-16">
              <div class="orgApp-d-flex">
                <app-date-picker [startAtDate]="startAtDate" [minDate]="currentDate" [maxDate]="maxStartDate" [isRequired]="true"
                  [selectedDate]="selectedDate" width="183px" (dateChanged)="selectedStartDate($event)" 
                  [editDate]="editStartDate" [dateLabel]="'holidays.create_holiday-dialog.content.label.date_from'"
                  [datePlaceHol]="'holidays.create_holiday-dialog.content.placeholder.start_date'" [currentLang]="currentLang">
                </app-date-picker>
              </div>

              <div class="orgApp-d-flex">
                <app-date-picker [startAtDate]="endAtDate" [minDate]="minEndDate" [maxDate]="maxEndDate" [isRequired]="true"
                  [selectedDate]="selectedEndDate" width="183px" (dateChanged)="selEndDate($event)" 
                  [editDate]="editEndDate" [dateLabel]="'holidays.create_holiday-dialog.content.label.date_until'"
                  [datePlaceHol]="'holidays.create_holiday-dialog.content.placeholder.end_date'" [currentLang]="currentLang">
                </app-date-picker>
              </div>
              @if(isSaveDisabled && createHolidaysForm.dirty && isFormModified && ((startDate.date !== '' && startDate.valid === false && isRealDate(startDate.date)) || (endDate.date !== '' && endDate.valid === false && isRealDate(endDate.date)))) {    <!-- since valid can be undefined in some cases, it's necessary to check whether it's false; isRealDate keeps this strictly for past (out-of-range) dates, not impossible ones --> 
                <div class="orgApp-d-flex orgapp-holiday-warning-info orgApp-flex-dir-row orgApp-gap-8">
                  <div>
                      <svg  width="16" height="16" viewBox="0 0 56 56"><use xlink:href="#orgApp-info"></use></svg>
                  </div>
                  <div>
                    {{
                      editMode ?
                      ("holidays.create_holiday-dialog.content.error_message.edit_with_past_date" | translate)
                      :("holidays.create_holiday-dialog.content.error_message.create_with_past_date" | translate) 
                    }}
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions
    class="orgApp-d-flex orgApp-holidays-action-button-container"
  >
    <mat-slide-toggle
      [checked]="isAvailable"
      (change)="onToggleChange($event.checked)"
      class="orgApp-toggle-color orgApp-holidays-toggle-btn"
      >{{
        "holidays.create_holiday-dialog.content.label.availability" | translate
      }}</mat-slide-toggle
    >
    <div class="orgApp-holidays-btn-container orgApp-d-flex orgApp-gap-8">
      <button
        mat-stroked-button
        class="orgApp-stroked-btn-primary orgApp-modal-button"
        (click)="cancelForm()"
      >
        {{ "holidays.create_holiday-dialog.action.cancel_btn" | translate }}
      </button>
      <button
        mat-raised-button
        [ngClass]="{
          disable: !createHolidaysForm.valid 
        }"
        class="orgApp-raised-btn-primary orgApp-modal-button"
        [disabled]="isSaveDisabled || !createHolidaysForm.valid "
        (click)="createHoliday()"
      >
        {{ editFormData.button | translate }}
      </button>
    </div>
  </mat-dialog-actions>
</div>
